import { useEffect, useMemo, useState } from 'react'
import { Link } from "react-router-dom"
import { Table, Select, Space, Input, Button, Modal, Carousel, DatePicker } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { baseAxiosNoInfo, baseAxiosComplete, axiosTable } from '../../tool/axios'
import { SelectStores } from '../../component/common/Selects'
import { SelectSingleProjectTypes } from "../../component/common/Selects"
import BreadCrumb from '../../component/BreadCrumb'
import getPermission from '../../js/permission'
import moment from 'moment'
import _ from 'lodash'

const { Column } = Table
const { Option } = Select
const { RangePicker } = DatePicker

type pagination = {
  current: number,
  pageSize: number,
  total: number,
}

type fetchParams = {
  store_id: string | undefined,
  customer_name: string | undefined,
  customer_phone: string | undefined,
  item_name: string | undefined,
  item_type_id: string | undefined,
  item_coperation_id: string | undefined,
  employee_id_adviser: string | undefined,
  employee_id_recover: string | undefined,
  date: any,
  review_status: string | undefined
}

export default function CkCollectionList() {

  let otherParamsTml = {
    store_id: undefined,
    customer_name: undefined,
    customer_phone: undefined,
    item_name: undefined,
    item_type_id: undefined,
    item_coperation_id: undefined,
    employee_id_adviser: undefined,
    employee_id_recover: undefined,
    date: undefined,
    review_status: undefined
  }

  let paginatioTml = {
    current: 1,
    pageSize: 10,
    total: 0
  }

  const [initDate, setInitDate] = useState<boolean>(true)

  const [otherParams, setOtherParams] = useState<fetchParams>(otherParamsTml)
  const [pagination, setPagination] = useState<pagination>(paginatioTml)

  const [tableList, setTableList] = useState<any[]>([])

  const [coperationList, setCoperation] = useState<any[]>([])
  const [adviseEmployeeList, setAdviseEmployeeList] = useState<any[]>([])
  const [recoverEmployeeList, setRecoverEmployeeList] = useState<any[]>([])

  const getCoperationList = coperationList.map((el: any) => (<Option value={el.coperation_id} key={el.coperation_id}  >{el.coperation_name}</Option>))
  const getAdviseEmployeeList = adviseEmployeeList.map((el: any) => (<Option value={el.employee_id} key={el.employee_id}  >{el.user_name}</Option>))
  const getRecoverEmployeeList = recoverEmployeeList.map((el: any) => (<Option value={el.employee_id} key={el.employee_id}  >{el.user_name}</Option>))

  const [imageList, setImageList] = useState<any[]>([])
  const [imageVisble, setImageVisble] = useState<boolean>(false)

  const permission: string[] = useMemo(() => {
    return getPermission()
  }, [window.location.pathname])

  useEffect(() => {
    // 获取产康合作商
    baseAxiosNoInfo.get('/chankang_center/coperation/select_list').then((response: any) => {
      setCoperation(response)
    })

    if (initDate) {
      var startDate = moment().startOf('month');
      var endDate = moment().endOf('month');
      // 初始化创建日期
      otherParams.date = [startDate, endDate];

      setInitDate(false)
    }

    fetch({ pagination, otherParams })
  }, [pagination.current])

  const getEmployeeList = (type: any, id: any) => {
    // 查询员工列表，包括：产康师、产康顾问
    baseAxiosNoInfo('/global/employee_list_by_position', { params: { position_number: type, department_id: id } }).then((res: any) => {
      if (res) {
        if (type == 4) {
          setAdviseEmployeeList(res)

        } else {
          setRecoverEmployeeList(res)
        }
      }
    })
  }

  const handleInputChange = (value: string, attr: string) => {
    let params: any = _.cloneDeep(otherParams)
    params[attr] = value

    setOtherParams(params)
  }

  const handleSelectChange = (value: string, attr: string) => {
    if (attr == 'store_id') {
      getEmployeeList(4, value)
      getEmployeeList(5, value)
    }

    let params: any = _.cloneDeep(otherParams)
    params[attr] = value

    setOtherParams(params)
  }

  const handleDateChange = (value: any, attr: any) => {
    let params: any = _.cloneDeep(otherParams)
    params[attr] = value

    setInitDate(false)
    setOtherParams(params)
  }

  const handleAgreement = (el: any) => {
    setImageList(el.pay_pic_list ? el.pay_pic_list.split(',') : [])
    setImageVisble(true)
  }

  const handleSearch = () => {
    let p: any = { ...pagination }
    p.current = 1
    setPagination(p)

    fetch({ pagination: p, otherParams })
  }

  const handleTableChange = (antPagination: any) => {
    const p = { ...pagination }
    p.current = antPagination.current

    setPagination(p)
  }

  const fetch = ({ pagination, otherParams }: { pagination: Object, otherParams: object }) => {
    const iPagination: any = { ...pagination }
    iPagination.page_num = iPagination.current
    iPagination.page_size = iPagination.pageSize

    delete iPagination.current
    delete iPagination.pageSize
    delete iPagination.total

    let params: any = { ...otherParams }
    if (params.date) {
      params.create_start_date = params.date[0].format('YYYY-MM-DD')
      params.create_end_date = params.date[1].format('YYYY-MM-DD')

      delete params.date
    }

    axiosTable.get('/finance_center/chankang/pay_item/page_list', {
      params: {
        ...iPagination,
        ...params
      }

    }).then((response: any) => {
      if (response) {
        let p: any = { ...pagination }
        p.total = response.total

        setPagination(p)
        setTableList(response.records)
      }
    })
  }

  const resetForm = () => {
    // 清空初始数据
    setAdviseEmployeeList([]);
    setRecoverEmployeeList([]);

    setInitDate(false)
    setOtherParams(otherParamsTml)

    let p: any = { ...pagination }
    p.current = 1
    setPagination(p)

    fetch({ pagination: p, otherParams: otherParamsTml })
  }

  const exportExcel = () => {
    const iPagination: any = { ...pagination }
    iPagination.page_num = iPagination.current
    iPagination.page_size = iPagination.pageSize

    delete iPagination.current
    delete iPagination.pageSize
    delete iPagination.total

    let params: any = { ...otherParams }
    if (params.date) {
      params.create_start_date = params.date[0].format('YYYY-MM-DD')
      params.create_end_date = params.date[1].format('YYYY-MM-DD')

      delete params.date
    }

    baseAxiosComplete('/finance_center/chankang/pay_item/excel', {
      params: {
        ...iPagination,
        ...params
      }

    }).then(res => {
      if (res.status === 0) {
        window.open(res.data)
      }
    })
  }

  return <div className="common-page">
    {/* 财务中心 -> 财务管理 -> 产康收款项目 */}
    <BreadCrumb position={['财务中心', '产康收款项目']} />

    <div className="common-top-form">
      <Space direction="horizontal" wrap>
        <div style={{ marginRight: 8, marginBottom: 12 }}>
          <SelectStores valueProp="id" value={otherParams.store_id} onChange={(value: string) => { handleSelectChange(value, 'store_id') }} />
        </div>

        <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} value={otherParams.customer_name} placeholder="客户姓名" onChange={(e: { target: { value: string } }) => { handleInputChange(e.target.value, 'customer_name') }} />
        <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} value={otherParams.customer_phone} placeholder="联系方式" onChange={(e: { target: { value: string } }) => { handleInputChange(e.target.value, 'customer_phone') }} />

        <RangePicker className="fl" style={{ marginRight: 8, marginBottom: 12, width: 250 }} value={otherParams.date} placeholder={['下单开始日期', '下单结束日期']} onChange={(el: any) => (handleDateChange(el, 'date'))} />

        <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} value={otherParams.item_name} placeholder="项目名称" onChange={(e: { target: { value: string } }) => { handleInputChange(e.target.value, 'item_name') }} />
        <div className="fl" style={{ marginRight: 8, marginBottom: 12 }}>
          <SelectSingleProjectTypes value={otherParams.item_type_id} onChange={(value: string) => { handleSelectChange(value, 'item_type_id') }} />
        </div>
        <Select className="fl" style={{ marginRight: 8, marginBottom: 12, width: 180 }} value={otherParams.item_coperation_id} onChange={(value: string) => { handleSelectChange(value, 'item_coperation_id') }} placeholder="项目合作商">
          {getCoperationList}
        </Select>

        <Select className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} value={otherParams.employee_id_adviser} onChange={(value: string) => { handleSelectChange(value, 'employee_id_adviser') }} placeholder="产康顾问">
          {getAdviseEmployeeList}
        </Select>
        <Select className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} value={otherParams.employee_id_recover} onChange={(value: string) => { handleSelectChange(value, 'employee_id_recover') }} placeholder="产康师">
          {getRecoverEmployeeList}
        </Select>
      </Space>

      <div style={{ marginTop: 10 }}>
        {permission.includes('查询') && <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn fl" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>}
        <Button style={{ marginRight: 12, marginBottom: 12 }} icon={<RedoOutlined />} onClick={resetForm}>重置</Button>
        {permission.includes('导出') && <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={() => { exportExcel() }} type="dashed">导出</Button>}
      </div>
    </div>

    <div className="common-main">
      <Table dataSource={tableList} bordered={true} scroll={{ x: 'max-content' }} pagination={pagination} onChange={handleTableChange}>
        <Column title="门店" dataIndex="store_name" key="store_name" />
        <Column title="客户姓名" dataIndex="customer_name" key="customer_name" />
        <Column title="手机号" dataIndex="customer_phone" key="customer_phone" />
        <Column title="下单日期" dataIndex="create_date" key="create_date" />
        <Column title="订单来源" dataIndex="order_source_type_desc" key="order_source_type_desc" />
        <Column title="项目名称" dataIndex="item_name" key="item_name" />
        <Column title="项目次数" dataIndex="item_count" key="item_count" />
        <Column title="项目分类" dataIndex="item_type_name" key="item_type_name" />
        <Column title="项目合作商" dataIndex="item_coperation_name" key="item_coperation_name" />
        <Column title="收款金额" dataIndex="pay_amount" key="pay_amount" />

        <Column
          title="收款凭证"
          key="pay_pic_list"
          render={(text, record: any) => (
            <Space size="middle">
              <Button type="link" onClick={() => (handleAgreement(record))}>查看收款</Button>
            </Space>
          )}
        />

        <Column title="产康顾问" dataIndex="employee_name_adviser" key="employee_name_adviser" />
        <Column title="产康师" dataIndex="employee_name_recover" key="employee_name_recover" />
        <Column title="创建人" dataIndex="create_user_name" key="create_user_name" />

        <Column
          title="订单编号"
          key="action"
          fixed='right'
          render={(text, record: any) => (
            <Space size="middle">
              <Button type="link"><Link to={"/ck_order_detail/" + record.order_id + '/' + 'true'}>{record.order_code}</Link></Button>
            </Space>
          )}
        />
      </Table>
    </div>

    {/* 图片预览 */}
    <Modal title={'收款凭证'} visible={imageVisble} onCancel={() => { setImageVisble(false) }} footer={null}>
      <Carousel>
        {imageList.length && imageList.map((el: any, index: any) => (
          <img key={index} src={el}></img>
        ))}
      </Carousel>
    </Modal>
  </div>
}